export enum GtmEnum {
  BEGIN_CHECKOUT = "begin_checkout",
  ADDED_ADDRESSES = "add_shipping_info",
  ADDED_PAYMENT = "add_payment_info",
  CALCULATED_PRICE ="price_calculated",
  PURCHASED = "purchase",
  SITE_NAVIGATION = "navigation"
}
